import React from 'react';
import Newsletter from 'components/common/Newsletter';

function Footer() {
  const isHome = window.location.pathname === '/';

  return (
    <footer className="l-footer no-print">
      <div className="c-footer">
        <div className="row upper">
          <div className="column small-12 medium-6 logo-wrapper">
            <div className="logo-slogan">
              <a
                href="https://resourcegovernance.org/"
                alt="NRGI"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/nrgi-logo.png" alt="NRGI logo" />
              </a>
            </div>
          </div>
          <div className="column small-12 medium-6">
            <Newsletter />
          </div>
        </div>
        <div className="row lower">
          <div className="column small-12 medium-8 rights">
            <img src="/images/by.svg" alt="NRGI logo" className="cc" />
            <p>Data and written content is licensed under Creative Commons Attribution 4.0 International License (CC BY 4.0). When cited attribute to: “2021 Resource Governance Index, Natural Resource Governance Institute (NRGI).” Images, photographs, and video content depicted on this site are excluded from this license, except where noted.</p>
            {isHome && <p>Upper photograph by Lauren DeCicca for NRGI; lower photograph by Suthep Kritsanavarin for NRGI.</p>}
          </div>
          <div className="column small-12 medium-4">
            <div className="social-authorship">
              <ul className="social-list">
                <li className="social-item">
                  <a
                    href="https://www.facebook.com/nrginstitute"
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="NRGI Institute Twitter"
                  >
                    <svg className="icon -facebook -blue"><use xlinkHref="#icon-facebook"></use></svg>
                  </a>
                </li>
                <li className="social-item">
                  <a
                    href="https://twitter.com/NRGInstitute"
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="NRGI Institute Facebook"
                  >
                    <svg className="icon -twitter -blue"><use xlinkHref="#icon-twitter"></use></svg>
                  </a>
                </li>
              </ul>
              <p className="authorship">Designed by
                <a
                  href="http://www.vizzuality.com"
                  alt="Vizzuality"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg className="icon -vizzuality -blue"><use xlinkHref="#icon-logo-vizzuality"></use></svg>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./app/components/common/Footer.jsx